import { render, staticRenderFns } from "./SimpleVideo.vue?vue&type=template&id=531e07bd"
import script from "./SimpleVideo.vue?vue&type=script&lang=js"
export * from "./SimpleVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531e07bd')) {
      api.createRecord('531e07bd', component.options)
    } else {
      api.reload('531e07bd', component.options)
    }
    module.hot.accept("./SimpleVideo.vue?vue&type=template&id=531e07bd", function () {
      api.rerender('531e07bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SimpleVideo.vue"
export default component.exports